// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Button, Divider, Icon, Text } from '@lmc/ui-kit'
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import style from 'styled-components'
import { ErrorBox, HelpLink } from '../generic'

interface PopupModalProps {
  testId?: string
  [key: string]: any
}

class PopupModal extends Component<PopupModalProps, any> {
  backdrop = null

  handleClose = () => {
    const { close, onClose } = this.props
    close()
    if (onClose) onClose()
  }

  handleBackdropClick = (e) => {
    if (e.target === this.backdrop) this.handleClose()
  }

  setBackdropRef = (element) => {
    this.backdrop = element
  }

  renderHeader = () => {
    const { type, list, title, subtitle, titleDescription, titleIcon, testId } =
      this.props
    const titleMap = {
      create: `Add a new ${list}`,
      edit: `Edit ${list}`
    }
    return (
      <div
        style={styles.headerContainer}
        data-testid={
          testId
            ? `${testId}-popup-modal-header-container`
            : 'popup-modal-header-container'
        }
      >
        <div style={styles.header}>
          <div style={styles.titleWrapper}>
            <div style={styles.titleAndIcon}>
              {titleIcon && <div>{titleIcon}</div>}
              <Text
                as="h4"
                style={styles.title}
                data-testid={
                  testId ? `${testId}-popup-modal-title` : 'popup-modal-title'
                }
              >
                {title || titleMap[type]}
              </Text>
            </div>
            {titleDescription && (
              <Text
                as="h5"
                style={styles.titleDescription}
                data-testid={
                  testId
                    ? `${testId}-popup-modal-title-description`
                    : 'popup-modal-title-description'
                }
              >
                {titleDescription}
              </Text>
            )}
          </div>

          <div
            className="lmc-action-button"
            id="close-edit-modal"
            onClick={this.handleClose}
            style={styles.closeWrapper}
            data-testid={
              testId
                ? `${testId}-popup-modal-close-button`
                : 'popup-modal-close-button'
            }
          >
            <Icon name="CloseOutlined" />
          </div>
        </div>
        {subtitle && (
          <div
            style={styles.subtitle}
            data-testid={
              testId ? `${testId}-popup-modal-subtitle` : 'popup-modal-subtitle'
            }
          >
            {subtitle}
          </div>
        )}
      </div>
    )
  }

  renderRequiredMessage = () => {
    const { testId } = this.props
    return (
      <div
        style={styles.required}
        data-testid={
          testId
            ? `${testId}-popup-modal-required-message`
            : 'popup-modal-required-message'
        }
      >
        Required fields are marked with <span style={styles.asterisk}>*</span>
        <StyledDivider />
      </div>
    )
  }

  render() {
    const {
      buttonColour,
      buttonDisabled,
      buttonIcon,
      buttonStyle,
      buttonType,
      children,
      confirmText,
      errors,
      includesRequired,
      isSubmitting,
      onConfirm,
      supportArticle,
      supportLink,
      helpStyle,
      footerStyle,
      style,
      testId
    } = this.props

    // Note that footerStyle can be used to set the justify-content prop of the
    // footer

    return (
      <div
        style={styles.modalContainer}
        data-testid={
          testId ? `${testId}-popup-modal-container` : 'popup-modal-container'
        }
      >
        <div
          style={styles.backdrop}
          ref={this.setBackdropRef}
          onClick={this.handleBackdropClick}
          onTouchEnd={this.handleBackdropClick}
          data-testid={
            testId ? `${testId}-popup-modal-backdrop` : 'popup-modal-backdrop'
          }
        />
        <div
          className="lmc-popup-modal"
          style={{
            ...styles.wrapper,
            ...style,
            maxHeight: isDesktop ? null : '90%',
            width: !this.props.titleDescription
              ? isDesktop
                ? null
                : '90%'
              : 'max-content'
          }}
          data-testid={
            testId ? `${testId}-popup-modal-wrapper` : 'popup-modal-wrapper'
          }
        >
          {this.renderHeader()}
          {includesRequired && this.renderRequiredMessage()}
          <ErrorBox errors={errors} style={{ margin: '0px 20px 20px 20px' }} />
          <div
            style={styles.childWrapper}
            data-testid={
              testId ? `${testId}-popup-modal-content` : 'popup-modal-content'
            }
          >
            {children}
            <StyledDivider />
          </div>

          <div
            style={{ ...styles.footerContainer, ...footerStyle }}
            data-testid={
              testId ? `${testId}-popup-modal-footer` : 'popup-modal-footer'
            }
          >
            {supportArticle && (
              <HelpLink
                supportLink={supportArticle}
                style={{
                  ...helpStyle,
                  float: 'right',
                  margin: '8px 20px 0px 0px'
                }}
              />
            )}
            {supportLink && supportLink}

            <div>
              {/* If a buttonIcon is provided, render using 
                            GlyphButton. Else it'll render the standard button */}
              {buttonIcon ? (
                <Button
                  id="popup-modal-primary-action"
                  disabled={isSubmitting || buttonDisabled}
                  onClick={onConfirm}
                  style={{
                    ...styles.saveButton,
                    background: buttonColour,
                    ...buttonStyle
                  }}
                  icon={<Icon name={buttonIcon} />}
                  variant="primary"
                  data-cy="btn-submit"
                  data-testid={
                    testId
                      ? `${testId}-popup-modal-confirm-button`
                      : 'popup-modal-confirm-button'
                  }
                >
                  {confirmText}
                </Button>
              ) : (
                <Button
                  id="popup-modal-primary-action"
                  disabled={isSubmitting}
                  style={styles.saveButton}
                  onClick={onConfirm}
                  variant="primary"
                  dataTestId="next-client-slide"
                  data-testid={
                    testId
                      ? `${testId}-popup-modal-confirm-button`
                      : 'popup-modal-confirm-button'
                  }
                >
                  {confirmText || 'Save'}
                </Button>
              )}
              <Button
                variant="default"
                id="popup-modal-secondary-action"
                data-cy="btn-cancel"
                onClick={this.handleClose}
                style={styles.cancelButton}
                ghost
                data-testid={
                  testId
                    ? `${testId}-popup-modal-cancel-button`
                    : 'popup-modal-cancel-button'
                }
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PopupModal

const isDesktop = isBrowser || isTablet

const styles = {
  asterisk: {
    color: colors.red,
    fontSize: 14,
    fontWeight: 'bold'
  },
  cancelButton: {
    marginRight: 12
  },
  childWrapper: {
    margin: '0px 20px 20px 20px'
  },
  closeWrapper: {
    cursor: 'pointer',
    transition: 'color .2s ease'
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingLeft: 20
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  backdrop: {
    background: 'black',
    opacity: 0.5,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 100
  },
  required: {
    bottom: 20,
    color: colors.darkgrey,
    fontSize: 13,
    padding: '0px 20px',
    position: 'relative'
  },
  saveButton: {
    float: 'right',
    color: 'white',
    fontSize: 14,
    textShadow: 'none',
    margin: '0px 20px 20px 0px'
  },
  headerContainer: {
    padding: 20
  },
  title: {
    fontWeight: 500
  },
  subtitle: {
    fontSize: 12,
    color: colors.darkgrey,
    paddingTop: 4
  },
  titleDescription: { marginTop: 0, fontWeight: 500, color: colors.silver },
  modalContainer: {
    minWidth: 200
  },
  wrapper: {
    background: 'white',
    borderRadius: 10,
    left: '50%',
    maxHeight: 550,
    opacity: 1,
    overflowY: 'auto',
    position: 'fixed',
    top: '50%',
    zIndex: 200
  },
  titleWrapper: { display: 'flex', flexDirection: 'column' },
  titleAndIcon: { display: 'flex', alignItems: 'center', gap: 8 }
}

const StyledDivider = style(Divider)`
  margin: 24px 0 0 0;
`
